
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/[articleSlug]",
      function () {
        return require("private-next-pages/[slug]/[articleSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/[articleSlug]"])
      });
    }
  